module.exports = __webpack_public_path__ + "static/media/zeya_nodding_head2.fc4ffbae.png";